import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import BlogInputForm from "./MarketingAgentBlogInputForm";
import "./MarketingAgentBlogGenerator.css"; // Import the updated CSS

const BlogGenerator = () => {
  const [blogText, setBlogText] = useState("");
  const [analysis, setAnalysis] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  // Animate on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (containerRef.current) observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, []);

  const handleGenerateBlog = async (formData) => {
    setLoading(true);

    try {
      // Send inputs to Flask API
      const response = await fetch("https://agentsserver.modlee.ai:5000/generate_blog", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) throw new Error("Failed to generate blog");
      const data = await response.json();
      setBlogText(data.blog_text || "No blog generated.");

      // Send blog text for ChatGPT analysis
      const analysisResponse = await fetch("https://agentsserver.modlee.ai:5000/analyze_blog", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ text: data.blog_text }),
      });

      if (!analysisResponse.ok) throw new Error("Failed to analyze blog");
      const analysisData = await analysisResponse.json();
      setAnalysis(analysisData.analysis || "No analysis available.");
    } catch (error) {
      console.error("Error:", error);
      setBlogText("Error generating blog.");
      setAnalysis("Error analyzing blog.");
    }

    setLoading(false);
  };


  return (
    <div ref={containerRef} className={`blog-generator-container ${isVisible ? "visible" : ""}`}>
      <h2 className="blog-generator-title">Test the Core Docs Agent for SEO Blog Creation</h2>
      <p className="blog-generator-description">
          Experience our Core Docs Agent in action! This demo lets you generate a high-quality, SEO-optimized blog post based on key details you provide. See how our AI streamlines content creation, ensuring well-structured, engaging, and search-friendly articles for your business.
      </p>

      {/* User Input Form */}
      <BlogInputForm onGenerate={handleGenerateBlog} />

      {/* Blog Output */}
      {loading ? (
        <p className="blog-output">Generating blog ... this may take a minute or two</p>
      ) : (
        blogText && (
          <div className="blog-output">
            <h3>Marketing Agent Generated Blog</h3>
            <div className="blog-content">
                {/* <ReactMarkdown>{}</ReactMarkdown> */}
                {blogText}
            </div>
          </div>
        )
      )}

      {/* Blog Analysis */}
      {/* {analysis && (
        <div className="blog-analysis">
          <h3>Editor Agent Blog Analysis</h3>
          <div className="analysis-content">
            {analysis}
          </div>
        </div>
      )} */}
    </div>
  );
};

export default BlogGenerator;
